import { gql } from '@apollo/client'

export const Query = gql`
  query ClientTypes($companyId: ID!, $filters: ClientTypeFilters, $order: ClientTypeOrder, $after: String, $before: String, $first: Int, $last: Int) {
    clientTypes(companyId: $companyId, filters: $filters, order: $order, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        name
        color
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
